import React from 'react';
import { Flex, TextV2, TooltipV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { TILE_TAG_BORDER_RADIUS } from '../HotelTile.constants';
import type { BottomTagProps } from '../HotelTile.types';

const TAG_STYLES = {
  neutral: { bg: 'mono2', textColor: 'mono12' },
  warning: { bg: 'warning2', textColor: 'mono12' },
} as const;

export const BottomTag: React.FC<BottomTagProps> = React.memo(({ tag }) => {
  const variant = tag.variant ?? 'neutral';
  const style = TAG_STYLES[variant];

  const tagElement = (
    <Flex
      alignItems="center"
      backgroundColor={style.bg}
      borderRadius={pxToRem(TILE_TAG_BORDER_RADIUS)}
      paddingX={2}
      paddingY={1}
      width="fit-content"
    >
      <TextV2
        typographyVariant="label2"
        color={style.textColor}
      >
        {tag.label}
      </TextV2>
    </Flex>
  );

  if (!tag.tooltip) return tagElement;

  return (
    <TooltipV2
      overrides={{
        Content: { props: { paddingY: 4, paddingX: 4, borderRadius: pxToRem(12), color: 'white', maxWidth: pxToRem(300) } },
      }}
      content={
        <TextV2
          typographyVariant="label2"
          color="mono4"
        >
          {tag.tooltip}
        </TextV2>
      }
      placement="top"
      onMouseEnterDelay={500}
    >
      {tagElement}
    </TooltipV2>
  );
});

BottomTag.displayName = 'HotelTile.BottomTag';
